module.exports = __webpack_public_path__ + "static/img/bgimg.ca692ad2.png";